import React from "react";
import { BookOpenIcon, CheckIcon, GiftIcon, GlobeIcon, LockIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../ui/CtaButton";
import { Countdown } from "../ui/Countdown";
import { ScarcityBar } from "../ui/ScarcityBar";
const perks = ["One-time payment", "Lifetime access", "No monthly fees", "Instant digital access"];
export function Offer() {
  return <section id="offer" className="bg-cream px-4 py-16 sm:px-5 sm:py-24" aria-labelledby="offer-title" data-id="element-204" data-mp="3a4dxa9j5yi6j">
      <div className="mx-auto max-w-2xl overflow-hidden rounded-3xl bg-white shadow-2xl shadow-brand-900/15 ring-2 ring-brand-700" data-id="element-205" data-mp="3f3i6v1a02hxe">
        <div className="bg-brand-700 px-5 py-4 text-center" data-id="element-206" data-mp="3jxcycqvuk171">
          <p className="text-sm font-black uppercase tracking-widest text-white" data-id="element-207" data-mp="3nvshukspyrfp">Special launch offer</p>
        </div>

        <div className="px-5 pb-8 pt-7 sm:px-10" data-id="element-208" data-mp="3sxhv873ezh6y">
          <h2 id="offer-title" className="text-center font-serif text-[1.9rem] font-black leading-tight text-ink sm:text-4xl" data-id="element-209" data-mp="1pdoaxvm808o">
            Here's everything you'll receive <em className="italic text-brand-600" data-id="element-210" data-mp="1kmrmcbwyz67a">today</em>
          </h2>

          <img src={images.mainMockup} alt="Everything included in REFLEXOLOGY 360°" className="mx-auto mt-6 w-full" data-id="element-211" data-mp="1fllwqmylvz1z" />

          <dl className="mt-6 divide-y divide-brand-100 rounded-2xl bg-brand-50 px-4" data-id="element-212" data-mp="1bl1xnduh2ld7">
            <div className="flex items-center justify-between gap-3 py-4" data-id="element-213" data-mp="16n9x5vfrhqxe">
              <dt className="flex items-center gap-3 text-[17px] font-bold text-ink" data-id="element-214" data-mp="23awndbm8sd2e">
                <BookOpenIcon className="h-5 w-5 shrink-0 text-brand-600" aria-hidden="true" data-id="element-215" data-mp="1z9upoz7z492j" />
                Reflexology 360°™ — 6 Premium Volumes
              </dt>
              <dd className="shrink-0 font-semibold text-ink/60 line-through" data-id="element-216" data-mp="1uhba5wpq73v3">$97</dd>
            </div>
            <div className="flex items-center justify-between gap-3 py-4" data-id="element-217" data-mp="2mzyp0ue4pmnq">
              <dt className="flex items-center gap-3 text-[17px] font-bold text-ink" data-id="element-218" data-mp="2n19vx32vfaj2">
                <GiftIcon className="h-5 w-5 shrink-0 text-brand-600" aria-hidden="true" data-id="element-219" data-mp="2i7ns80eoqgze" />
                5 Exclusive Bonuses
              </dt>
              <dd className="shrink-0 font-semibold text-ink/60 line-through" data-id="element-220" data-mp="364ali83xnqyy">$147</dd>
            </div>
            <div className="flex items-center justify-between gap-3 py-4" data-id="element-221" data-mp="2sdf58ar3u7lc">
              <dt className="text-[17px] font-black uppercase text-ink" data-id="element-222" data-mp="2sbciq0p5uwld">Total reference value</dt>
              <dd className="shrink-0 text-xl font-black text-rose-600 line-through" data-id="element-223" data-mp="2wce8zs13nyb7">$244</dd>
            </div>
          </dl>

          <div className="mt-8 text-center" data-id="element-224" data-mp="2nelswlnk0mmr">
            <p className="text-lg font-semibold text-ink/70" data-id="element-225" data-mp="2nfng1ohugzku">But today… you don't pay $244.</p>
            <p className="mt-1 text-base font-bold uppercase tracking-wide text-brand-700" data-id="element-226" data-mp="29fvvf4wtokxv">You get everything for just</p>
            <p className="mt-1 font-serif text-[5.5rem] font-black leading-none text-brand-800 sm:text-[7rem]" data-id="element-227" data-mp="2dhzbk6ufsdph">
              <span className="align-top text-4xl sm:text-5xl" data-id="element-228" data-mp="boji726yskqt">$</span>27
            </p>
            <p className="mt-1 text-sm font-bold uppercase tracking-widest text-ink/60" data-id="element-229" data-mp="bmfd4gxbxfoy">USD · One-time payment</p>
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-230" data-mp="1s5ijxcjqovve">
            {perks.map(perk => <li key={perk} className="flex items-center gap-2 rounded-xl bg-brand-50 px-3 py-2.5 text-sm font-bold text-brand-800" data-id="element-231" data-mp="25w3u8cv4nxho">
                <CheckIcon className="h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-232" data-mp="214vivba8m21v" />
                {perk}
              </li>)}
          </ul>

          <ScarcityBar data-id="element-233" data-mp="2avzx28s39ivn" />

          <div className="mt-6" data-id="element-234" data-mp="2auou2b6gwf5l">
            <CtaButton label="Yes! I want Reflexology 360°" data-id="element-235" data-mp="2axkr7xahqzsz" />
          </div>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-ink/60" data-id="element-236" data-mp="2oupuxqmqfml2">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-237" data-mp="2jwofrgsfg7ev" />
            One-time payment of $27 · Instant Access · Lifetime Access · 7-Day Guarantee
          </p>

          <div className="mt-5 flex items-start gap-3 rounded-2xl border border-brand-200 bg-brand-50 p-4" data-id="element-238" data-mp="pj6xo9ask2r8">
            <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" aria-hidden="true" data-id="element-239" data-mp="rw0ohgdktsmh" />
            <p className="text-sm leading-snug text-ink/80" data-id="element-240" data-mp="vxcjy2j4t82l">
              <strong className="text-ink" data-id="element-241" data-mp="10xgxbjoqtmol">Automatic currency conversion.</strong> Pay in your local currency — the price
              is converted automatically at checkout, wherever you are in the world.
            </p>
          </div>

          <Countdown data-id="element-242" data-mp="89ukrlxjf7pl" />
          <p className="mt-4 text-center text-base text-ink/75" data-id="element-243" data-mp="8amhj02vfbhg">Get REFLEXOLOGY 360°™ today for the special launch price.</p>
        </div>
      </div>
    </section>;
}